export default {
  step: state => state.step,
  schemas: state => state.schemas,
  mapping: state => state.mapping,
  templates: state => state.templates,
  delimiter: state => state.delimiter,
  mappingId: state => state.mappingId,
  rowsToSkip: state => state.rowsToSkip,
  schemaName: state => state.schemaName,
  mappedData: state => state.mappedData,
  corporateId: state => state.corporateId,
  visitedStep: state => state.visitedStep,
  templateName: state => state.templateName,
  schemaColumns: state => state.schemaColumns,
  isSkipChecked: state => state.isSkipChecked,
  fileDataArray: state => state.fileDataArray,
  delimiterOptions: state => state.delimiterOptions,
  csvData: state => state.csvData
  // addressError: state => state.addressError,
  // addressApproved: state => state.addressApproved,
  // addressDuplicate: state => state.addressDuplicate
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/import-data/getters.js